<!-- 申请单申请页面 -->
<template>
  <div class="app-container">
    <el-card>
      <el-divider
        direction="horizontal"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff', padding: '0 5px' }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          申请单信息
        </h3>
      </el-divider>
      <el-form
        ref="formRef"
        class="mt25"
        :model="formData"
        inline
        label-position="top"
        :rules="formRules"
      >
        <el-form-item prop="name" label="申请单名称">
          <el-input v-model="formData.name" style="width: 240px" />
        </el-form-item>
        <el-form-item label="申请单类型" prop="type">
          <el-select
            v-model="formData.type"
            filterable
            clearable
            placeholder="请选择申请单类型"
            style="width: 240px"
            @change="handleApplicationTypeChange"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('applicationType')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
              :disabled="
                formData.outInStatus === '1' && subItem.libraryCode === '4'
              "
            />
          </el-select>
        </el-form-item>
        <el-form-item label="出入库类型" prop="outInStatus">
          <el-select
            ref="ceshiRef"
            v-model="formData.outInStatus"
            filterable
            clearable
            placeholder="请选择出入库类型"
            style="width: 240px"
            @change="handleOutInStatusChange"
          >
            <el-option
              v-for="subItem in getDictListByParentCode('outInStatus')"
              :key="subItem.libraryCode"
              :label="subItem.libraryName"
              :value="subItem.libraryCode"
              :disabled="
                (formData.type === '4' || formData.type === '7') &&
                subItem.libraryCode === '1'
              "
            />
          </el-select>
        </el-form-item>
        <!-- 退货入库|项目入库 -->
        <template
          v-if="
            ['1', '4'].includes(formData.type) && formData.outInStatus === '1'
          "
        >
          <el-form-item label="入库仓库" prop="inWarehouse">
            <el-select
              v-model="formData.inWarehouse"
              filterable
              clearable
              placeholder="请选择入库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <!-- 退货出库|项目出库|普通出库 -->
        <template
          v-if="
            ['1', '4', '7'].includes(formData.type) &&
            formData.outInStatus === '2'
          "
        >
          <el-form-item label="出库仓库" prop="outWarehouse">
            <el-select
              v-model="formData.outWarehouse"
              filterable
              clearable
              placeholder="请选择出库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <!-- 调拨入库 -->
        <template v-if="formData.type === '2' && formData.outInStatus === '1'">
          <el-form-item label="入库仓库" prop="inWarehouse">
            <el-select
              v-model="formData.inWarehouse"
              filterable
              clearable
              placeholder="请选择入库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :disabled="subItem.warehouseId === formData.outWarehouse"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="出库仓库" prop="outWarehouse">
            <el-select
              v-model="formData.outWarehouse"
              filterable
              clearable
              placeholder="请选择出库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in superWarehouseList"
                :disabled="subItem.warehouseId === formData.inWarehouse"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <!-- 调拨出库 -->
        <template v-if="formData.type === '2' && formData.outInStatus === '2'">
          <el-form-item label="出库仓库" prop="outWarehouse">
            <el-select
              v-model="formData.outWarehouse"
              filterable
              clearable
              placeholder="请选择出库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in warehouseList"
                :disabled="subItem.warehouseId === formData.inWarehouse"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="入库仓库" prop="inWarehouse">
            <el-select
              v-model="formData.inWarehouse"
              filterable
              clearable
              placeholder="请选择入库仓库"
              style="width: 240px"
            >
              <el-option
                v-for="subItem in superWarehouseList"
                :disabled="subItem.warehouseId === formData.outWarehouse"
                :key="subItem.warehouseId"
                :label="subItem.warehouseName"
                :value="subItem.warehouseId"
              />
            </el-select>
          </el-form-item>
        </template>
        <!-- 退货入库关联出库单 -->
        <template v-if="formData.type === '1' && formData.outInStatus === '1'">
          <el-form-item label="关联出库单" prop="outInRecordsName">
            <template class="connectApplication">
              <el-tooltip
                v-if="formData.outInRecordsName?.length > 0"
                effect="dark"
                :content="formData.outInRecordsName"
                placement="bottom"
              >
                <el-input
                  v-model="formData.outInRecordsName"
                  disabled
                  clearable
                  placeholder="请选择关联出库单"
                  style="width: 240px"
                />
              </el-tooltip>
              <el-input
                v-else
                v-model="formData.outInRecordsName"
                disabled
                clearable
                placeholder="请选择关联出库单"
                style="width: 240px"
              />
              <el-button class="ml10" type="primary" @click="handleChoose"
                >选择关联出库单</el-button
              >
            </template>
          </el-form-item>
        </template>
        <el-form-item label="备注" prop="remarks" v-if="formData.type === '7'">
          <el-input v-model="formData.remarks" style="width: 240px" />
        </el-form-item>
        <el-form-item label="备注" v-else>
          <el-input v-model="formData.remarks" style="width: 240px" />
        </el-form-item>
      </el-form>
      <el-divider
        direction="horizontal"
        :style="{
          color: '#1989fa',
          borderColor: '#d0e6ff',
          marginTop: '25px',
          padding: '0 5px',
        }"
        content-position="left"
      >
        <h3 class="form-title" style="color: #409eff; font-weight: bolder">
          申请产品信息
        </h3>
      </el-divider>
      <SelectProductTable
        class="mt25"
        ref="selectProductTableRef"
        :data="selectProductTableData"
        :isApplication="true"
        :warehouseId="
          formData.outInStatus === '1'
            ? formData.inWarehouse
            : formData.outWarehouse
        "
      />
      <el-divider
        direction="horizontal"
        border-style="dashed"
        :style="{ color: '#1989fa', borderColor: '#d0e6ff' }"
      >
      </el-divider>
      <el-row :gutter="8" class="mt5">
        <el-col :span="1.5">
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </el-col>
      </el-row>
    </el-card>
    <Dialog
      title="选择出库单"
      :modelValue="dialogApplication"
      width="60%"
      @onConfirm="handleConfirm"
      @onClosed="handleClosed"
    >
      <template #content>
        <Table
          :data="tableData"
          ref="tableRef"
          :columns="columns"
          height="500"
          :total="total"
          :loading="loading"
          :showFun="true"
          :isSelect="true"
          :isCreateSearch="false"
          :customJsonParamsFun="getCustomJsonParamsFun"
          rowKey="outInRecordsId"
          @onSearch="handleSearch"
        >
          <template #henderExtend>
            <div style="width: calc(60vw - 650px)">
              <el-dropdown
                placement="bottom"
                style="float: right"
                trigger="click"
              >
                <el-button type="primary" plain
                  >暂存数据({{
                    Object.values(selectOutInRecordsData).length
                  }})</el-button
                >
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="item in Object.values(selectOutInRecordsData)"
                      style="min-width: 150px"
                      >{{ item.name }}
                      <div style="width: 10px; height: 14px; line-height: 14px">
                        <svg-icon
                          style="position: absolute; right: 10px; color: red"
                          iconClass="delete"
                          @click.stop="handleDeleteSelectOutInRecords(item)"
                        />
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </template>
        </Table>
      </template>
      <template #extendBtn>
        <el-button type="primary" plain @click="handleSelectOutInRecordsData"
          >暂存选中项</el-button
        >
      </template>
    </Dialog>
    <el-dialog
      title="出库单详情"
      v-model="applicationDetailDialog"
      width="60%"
      @close="applicationDetailHandleClosed"
    >
      <Table
        :data="applicationDetailDate"
        ref="applicationDetailTableRef"
        :columns="applicationDetailColumns"
        maxHeight="500"
        :total="applicationDetailTotal"
        :loading="applicationDetailLoading"
        :showFun="true"
        :isCreateSearch="false"
        rowKey="productRecordsId"
        tableName="applicationDetail"
        @onSearch="applicationDetailHandleSearch"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="applicationDetailHandleClosed">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="产品明细"
      v-model="productDialog"
      width="60%"
      @close="productHandleClosed"
    >
      <Table
        ref="productDialogTableRef"
        :showSearchIcon="false"
        :isCreateSearch="false"
        :data="productDate"
        :columns="productColumns"
        :total="productTotal"
        :loading="productLoading"
        :searchAttrName="searchAttrName"
        rowKey="productRecordsId"
        tableName="applicationProduct"
        @onSearch="productHandleSearch"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="productHandleClosed">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, nextTick } from "vue";
import SelectProductTable from "@/views/warehouse/components/SelectProductTable";
import useCacheStore from "@/store/modules/cache";
import { addApplicationForm } from "@/api/warehouse/applicationForm";
import { listOutInputRecords } from "@/api/warehouse/outInWarehouse";
import {
  selectProductInventoryByProductRecordsId,
  selectProductRecordsByOutInRecordsId,
} from "@/api/warehouse/warehouseDate";
import { isNull } from "@/utils/fangerUtils";
import { errorMsg } from "@/utils/msgBox";
import Dialog from "@/components/Element/Dialog";
import Table from "@/components/Element/Table";
const cacheStore = useCacheStore();
const { proxy } = getCurrentInstance();
const { getDictListByParentCode, getWarehouseNameById, getProductById } =
  cacheStore;
const warehouseList = cacheStore.warehouse;
import { getCustomTableCols } from "@/tableColumn";
const superWarehouseList = cacheStore.superWarehouse;
const formRef = ref(null);
const selectProductTableRef = ref(null);
const selectProductTableData = ref([]);
const formData = ref({});
const tableData = ref([]);
const outInRecords_id = ref("");
const searchAttrName = ["eqptCode"];
const handleDetail = (event, row) => {
  outInRecords_id.value = row.outInRecordsId;
  applicationDetailDialog.value = true;
  proxy.$nextTick(() => {
    applicationDetailTableRef.value.onSearch();
  });
};
const productRecords_id = ref("");
const productDialog = ref(false);
const productDialogTableRef = ref(null);
const applicationDetailHandleDetail = (event, row) => {
  productRecords_id.value = row.productRecordsId;
  productDialog.value = true;
  proxy.$nextTick(() => {
    productDialogTableRef.value.onSearch();
  });
};

const ceshiRef = ref(null);
const total = ref(0);
const loading = ref(false);
// 申请类型改变
const handleApplicationTypeChange = (value) => {
  delete formData.value.outWarehouse;
  delete formData.value.inWarehouse;
};

// 出入库类型改变
const handleOutInStatusChange = (value) => {
  delete formData.value.outWarehouse;
  delete formData.value.inWarehouse;
};

// 正在保存中标志，防止鼠标误点多次提交
const saveIngFlag = ref(false);

// 提交数据
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    if (!valid) return;
    if (saveIngFlag.value) {
      return;
    }
    const productData = selectProductTableRef.value.getProductData();
    if (productData === null) return;
    if (formData.value.type === "1" && formData.value.outInStatus === "1") {
      // 提交时校验数量   产品所有数量比较已完成数量
      let productObj = {};
      productData.forEach((item) => {
        if (productObj[item.productId]) {
          productObj[item.productId] += item.productNum;
        } else {
          productObj[item.productId] = item.productNum;
        }
      });
      let selectObj = {};
      selectProduct.value.forEach((item) => {
        if (selectObj[item.productId]) {
          selectObj[item.productId] += item.completeNum;
        } else {
          selectObj[item.productId] = item.completeNum;
        }
      });
      for (let key in productObj) {
        if (selectObj[key] === undefined) {
          let obj = productData.find((item) => item.productId == key);
          let proObj = getProductById(obj.productId);
          errorMsg(`${proObj.productName}不在出库单中`);
          return;
        } else {
          if (productObj[key] > selectObj[key]) {
            let obj = productData.find((item) => item.productId == key);
            let proObj = getProductById(obj.productId);
            errorMsg(`${proObj.productName}的产品数量超过出库单中已出数量`);
            return;
          }
        }
      }
    }

    // if (productData.length === 0) {
    //   errorMsg("请选择产品，最少选择一个产品");
    //   return;
    // }
    formData.value.jsonData = JSON.stringify(productData);
    if (isNull(formRef.value.applicationFormId)) {
      // 新增
      saveIngFlag.value = true;
      addApplicationForm(formData.value)
        .then((res) => {
          // 重置表单
          formData.value = {};
          formRef.value.resetFields();
          selectProductTableRef.value.clearProductData();
          saveIngFlag.value = false;
        })
        .catch((res) => {
          saveIngFlag.value = false;
        })
        .finally(() => {
          saveIngFlag.value = false;
        });
    }
  });
};

const dialogApplication = ref(false);
const handleChoose = () => {
  dialogApplication.value = true;
  selectOutInRecordsData.value = {};
  proxy.$nextTick(() => {
    tableRef.value.onSearch();
  });
};

const getCustomJsonParamsFun = (data) => {
  const reData = [
    {
      column: "status",
      value: "2",
      querLogic: "eq",
    },
  ];
  if (!isNull(formData.value.inWarehouse)) {
    reData.push({
      column: "outWarehouse",
      value: formData.value.inWarehouse,
      querLogic: "eq",
    });
  }
  return reData;
};

const handleSearch = (data) => {
  loading.value = true;
  listOutInputRecords({
    ...data,
  })
    .then((res) => {
      res.data?.forEach((item) => {
        item.inWarehouseName = getWarehouseNameById(item.inWarehouse);
      });
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
      proxy.$nextTick(() => {
        setSelectOutInRecordsSelectStatus();
      });
    })
    .catch((res) => {})
    .finally(() => {
      loading.value = false;
    });
};
const handleClosed = () => {
  dialogApplication.value = false;
};
const tableRef = ref(null);
// 出入库单暂存数据
const selectOutInRecordsData = ref({});
// 将已选择的数据加入到暂存区
const handleSelectOutInRecordsData = () => {
  const selectData = tableRef.value.getSelectedRows();
  selectData.forEach((item) => {
    if (!(item.outInRecordsId in selectOutInRecordsData.value)) {
      selectOutInRecordsData.value[item.outInRecordsId] = item;
    }
  });
};
// 删除暂存区的数据
const handleDeleteSelectOutInRecords = (deleteItem) => {
  delete selectOutInRecordsData.value[deleteItem.outInRecordsId];
  tableData.value.forEach((item) => {
    if (item.outInRecordsId === deleteItem.outInRecordsId) {
      tableRef.value.getTableRef().toggleRowSelection(item, false);
      return;
    }
  });
};

// 设置表格中暂存区已选择的数据
const setSelectOutInRecordsSelectStatus = () => {
  tableData.value.forEach((item) => {
    if (item.outInRecordsId in selectOutInRecordsData.value) {
      tableRef.value.getTableRef().toggleRowSelection(item, true);
    }
  });
};

const handleConfirm = () => {
  handleSelectOutInRecordsData();
  // 确认选择的申请单
  getProductRecordsRows(Object.values(selectOutInRecordsData.value));
};
const applicationDetailDialog = ref(false);
const applicationDetailDate = ref([]);
const applicationDetailLoading = ref(false);
const applicationDetailTotal = ref(0);
const applicationDetailTableRef = ref(null);

const applicationDetailHandleClosed = () => {
  applicationDetailDialog.value = false;
  applicationDetailDate.value = [];
};
const applicationDetailHandleSearch = () => {
  applicationDetailLoading.value = true;
  selectProductRecordsByOutInRecordsId(outInRecords_id.value)
    .then((data) => {
      const arr = [];
      data.data.forEach((item) => {
        item.oriIncompleteNumber = item.incompleteNum;
        item.canChange = true;
        arr.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      applicationDetailDate.value = arr;
      applicationDetailTotal.value = data.pageParam.totleInfo || 0;
    })
    .finally((data) => {
      applicationDetailLoading.value = false;
    });
};
const productDate = ref([]);
const productLoading = ref(false);
const productTotal = ref(0);

const productHandleClosed = () => {
  productDialog.value = false;
  productDate.value = [];
};
const productHandleSearch = () => {
  productLoading.value = true;
  selectProductInventoryByProductRecordsId({
    productRecordsId: productRecords_id.value,
  })
    .then((res) => {
      productDate.value = res.data;
      productTotal.value = res.pageParam.totleInfo || 0;
    })
    .finally((data) => {
      productLoading.value = false;
    });
};
// 出库单产品
const selectProduct = ref([]);
const getProductRecordsRows = (res) => {
  if (isNull(res)) return;
  formData.value.outInRecordsName = res.map((item) => item.name).join(",");
  formData.value.outInRecordsId = res
    .map((item) => item.outInRecordsId)
    .join(",");
  dialogApplication.value = false;
  // 根据id获取产品
  selectProductRecordsByOutInRecordsId(formData.value.outInRecordsId).then(
    (data) => {
      const arr = [];
      data.data.forEach((item) => {
        item.oriIncompleteNumber = item.incompleteNum;
        item.canChange = true;
        arr.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      selectProduct.value = arr;
      handleClosed();
    }
  );
};
// 表单规则
const formRules = {
  name: [
    {
      required: true,
      trigger: "blur",
      message: "申请单名称为必填项",
    },
  ],
  type: [
    {
      required: true,
      trigger: "blur",
      message: "申请单类型为必填项",
    },
  ],
  outInStatus: [
    {
      required: true,
      trigger: "blur",
      message: "出入库类型为必填项",
    },
  ],
  inWarehouse: [
    {
      required: true,
      trigger: "blur",
      message: "入库仓库为必填项",
    },
  ],
  outWarehouse: [
    {
      required: true,
      trigger: "blur",
      message: "出库仓库为必填项",
    },
  ],
  outInRecordsName: [
    {
      required: true,
      trigger: "blur",
      message: "请选择出库申请单",
    },
  ],
  remarks: [
    {
      required: true,
      trigger: "blur",
      message: "普通出库备注为必填项",
    },
  ],
};

const productColumns = getCustomTableCols([
  "contractNo",
  "batchNo",
  "projectNo",
  "workContactNo",
  "projectName",
  "checkStatus",
  "returnInWarehouse",
  "firstInWarehouseTime",
  "inWarehouseTime",
  "inventoryStatus",
  "outWarehouseTime",
  "checkInventoryDisposalMode",
  "eqptCode",
  "productNum",
  "inventoryOperationType",
  "remarks",
  "operateTime",
  "operatorName",
]);
const handleControlDisabled = (row) => {
  return row.usageType !== "1";
};
const applicationDetailColumns = getCustomTableCols([
  "productName",
  "productNum",
  { label: "已出数量", prop: "completeNum" },
  { label: "未出数量", prop: "incompleteNum" },
  "recipient",
  "operateTime",
  "operatorName",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "详情",
        controlType: "success",
        controlText: true,
        controlFun: applicationDetailHandleDetail,
        controlDisabled: handleControlDisabled,
      },
    ],
  },
]);
const columns = getCustomTableCols([
  "name",
  "outWarehouseTime",
  "outInType",
  "outWarehouse",
  "operateTime",
  "operatorName",

  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "详情",
        controlType: "success",
        controlText: true,
        controlFun: handleDetail,
      },
    ],
  },
]);
</script>

<style lang="scss" scoped>
.connectApplication {
  display: flex;
}
</style>
